document.addEventListener('DOMContentLoaded', function() {

	const modal = document.querySelector('[class="#modal-popup-dialog"]');
	
	const mutationCallback = (mutationsList) => {
	  for (const mutation of mutationsList) {
		if (
		  mutation.type !== "attributes" ||
		  mutation.attributeName !== "open"
		) {
		  return
		}
		console.log("Modal Open!");
	
		const buttonWrap = modal.querySelector('product-to-cart');
		buttonWrap.style.display = 'none';
	
		const element = document.createElement("a");
		element.className = "jar-dialog-atc";
		element.innerText = "Buy Now";
		element.wasClicked = false;
		element.setAttribute('style', `background-color: #e86697;
    								   color: #fff;
									   display: block;
									   text-align: center;
									   padding: 10px;
									   border-radius: 20px; cursor: pointer;
									   box-shadow:rgba(157, 24, 74, 0.3) 0 .15em .3em,rgba(157, 24, 74, 0.15) 0 .3em .6em -.15em,#d32063 0 -.15em 0 inset`);
		element.onclick = () => {
			if (element.wasClicked == false) {
				element.wasClicked = true;
				buttonWrap.querySelector('button').click();
			}
		}
		buttonWrap.parentElement.appendChild(element);
	  }
	}
	
	
	const observer = new MutationObserver(mutationCallback);
	observer.observe(modal, { attributes: true });
	
});